import React from 'react';
import './Placeholder.css';

const DITDRLPayments = () => {
  return (
    <div className="placeholder-page">
      <div className="page-header">
        <div>
          <h1 className="page-title">
            DIT/DRL Payments
            <span className="info-icon">⚠️</span>
          </h1>
          <p className="page-subtitle">Manage DIT and DRL payment transactions</p>
        </div>
      </div>
      <div className="placeholder-content">
        <p>DIT/DRL Payments page coming soon...</p>
      </div>
    </div>
  );
};

export default DITDRLPayments;

